(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brand-quantity-limit"] && !Shopify.designMode) return;
  try {
    (() => {
    let initializationAttempts = 0;

    const initialize = () => {
      const element = document.getElementById('SkinFactBrandQuantityLimit');
      if (!element) return;

      const limit = Number.parseInt(element.dataset.limit, 10);
      const vendors = new Set(
        element.dataset.vendors
          .split('|')
          .map((vendor) => vendor.trim().toLowerCase())
          .filter(Boolean)
      );
      let correctionPromise;
      let messageTimer;

      const isRestricted = (item) => vendors.has(String(item?.vendor || '').trim().toLowerCase());

      const showMessage = () => {
        window.clearTimeout(messageTimer);
        element.hidden = false;
        messageTimer = window.setTimeout(() => {
          element.hidden = true;
        }, 5000);
      };

      const setInputLimit = (input) => {
        const currentMaximum = Number.parseInt(input.getAttribute('max'), 10);
        const maximum = Number.isFinite(currentMaximum) ? Math.min(currentMaximum, limit) : limit;
        input.max = String(maximum);
        input.dataset.max = String(maximum);

        const quantityInput = input.closest('quantity-input');
        const plusButton = quantityInput?.querySelector('button[name="plus"]');
        if (plusButton) {
          plusButton.toggleAttribute('disabled', Number.parseInt(input.value, 10) >= maximum);
        }
      };

      const applyProductInputLimits = () => {
        document
          .querySelectorAll('[data-brand-quantity-limit] input.quantity__input[name="quantity"]')
          .forEach(setInputLimit);
      };

      const applyCartInputLimits = (cart) => {
        window.requestAnimationFrame(() => {
          const items = Array.isArray(cart?.items) ? cart.items : [];

          document.querySelectorAll('cart-items input.quantity__input[data-index]').forEach((input) => {
            const item = items[Number.parseInt(input.dataset.index, 10) - 1];
            if (isRestricted(item)) setInputLimit(input);
          });
        });
      };

      const getUpdates = (cart) => {
        const updates = {};
        const remainingByVariant = new Map();

        for (const item of cart.items || []) {
          if (!isRestricted(item)) continue;

          const variantId = String(item.variant_id);
          const remaining = remainingByVariant.has(variantId) ? remainingByVariant.get(variantId) : limit;
          const quantity = Math.max(0, Number.parseInt(item.quantity, 10) || 0);
          const allowedQuantity = Math.min(quantity, remaining);

          if (allowedQuantity !== quantity) {
            updates[item.key] = allowedQuantity;
          }

          remainingByVariant.set(variantId, remaining - allowedQuantity);
        }

        return updates;
      };

      const correctCart = (cart) => {
        applyProductInputLimits();
        applyCartInputLimits(cart);

        if (correctionPromise || !Array.isArray(cart?.items)) return correctionPromise;

        const updates = getUpdates(cart);
        if (Object.keys(updates).length === 0) return;

        correctionPromise = (async () => {
          document.documentElement.classList.add('brand-quantity-limit-correcting');
          document.querySelectorAll('[name="checkout"]').forEach((button) => {
            button.disabled = true;
          });

          const sections = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', {
              bubbles: true,
              detail: { sections },
            })
          );

          const response = await fetch(FoxTheme.routes.cart_update_url, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({
              updates,
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const updatedCart = await response.json();

          if (!response.ok || updatedCart.errors) {
            throw new Error(updatedCart.description || updatedCart.message || 'Unable to update cart');
          }

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            sources: 'brand-quantity-limit',
            cart: updatedCart,
          });
          showMessage();
          return updatedCart;
        })()
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            correctionPromise = undefined;
            document.documentElement.classList.remove('brand-quantity-limit-correcting');
            document.querySelectorAll('[name="checkout"]').forEach((button) => {
              button.disabled = false;
            });
          });

        return correctionPromise;
      };

      applyProductInputLimits();

      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (correctionPromise) {
          applyCartInputLimits(event.cart);
          return;
        }
        correctCart(event.cart);
      });

      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, () => {
        window.setTimeout(applyProductInputLimits);
      });

      fetch(FoxTheme.routes.cart_url + '.js', FoxTheme.utils.fetchConfig('json', 'GET'))
        .then((response) => response.json())
        .then(correctCart)
        .catch((error) => {
          console.error(error);
        });
    };

    const initializeWhenThemeIsReady = () => {
      const themeIsReady =
        window.FoxTheme?.routes?.cart_update_url &&
        window.FoxTheme?.routes?.cart_url &&
        window.FoxTheme?.utils?.fetchConfig &&
        window.FoxTheme?.pubsub?.subscribe &&
        window.FoxTheme?.pubsub?.publish &&
        window.FoxTheme?.pubsub?.PUB_SUB_EVENTS;

      if (themeIsReady) {
        initialize();
        return;
      }

      initializationAttempts += 1;
      if (initializationAttempts < 200) {
        window.setTimeout(initializeWhenThemeIsReady, 50);
      }
    };

    initializeWhenThemeIsReady();
  })();
  } catch(e) { console.error(e); }
})();

})();
